import { createI18n } from 'vue-i18n'

import { getLanguage } from '@/utils/cookies'

import elementEnLocale from 'element-plus/lib/locale/lang/en'
import elementZhLocale from 'element-plus/lib/locale/lang/zh-cn'

// User defined lang
import enLocale from './en'
import zhLocale from './zh-cn'
import enKilimall from './Kilimall/en'
import zhKilimall from './Kilimall/zh-cn'
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
    ...enKilimall
  },
  'zh-cn': {
    ...zhLocale,
    ...elementZhLocale,
    ...zhKilimall
  }
}
 
export const getLocale = () => {
  const cookieLanguage = getLanguage()
  if (cookieLanguage) {
    return cookieLanguage
  }

  const language = 'en'
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }

  // Default language is english
  return 'zh'
}

const i18n = createI18n({
  locale: getLocale(),
  messages: messages
})

export default i18n
